export default __webpack_public_path__ + "static/media/unknown-coin.43216508.svg";